import React, {useCallback, useEffect, useMemo, useState} from "react";
import {prediction} from "../../constants/copyright";
import {safeHTML} from "../../utils/safeHTML";
import Button from "../baseComponents/gui/button/Button";
import buttonStyles from "../baseComponents/gui/button/Button.module.scss";
import {CSSTransition, SwitchTransition} from "react-transition-group";
import storage from "../../utils/storage";
import RandomPicker from "./RandomPicker";
import classNames from "classnames";
import styles from "./Prediction.module.scss";


const Prediction = React.forwardRef(
  function Prediction(props, ref) {
    const {list,onRoute,className, tag} = props;
    const [randomText, setRandomText] = useState(null);
    const Tag = tag;

    const randomPredictions = new RandomPicker(list)

    const randomTextAction = useCallback(() => {
      const currentDay = getCurrentDate()
      storage('datePrediction').save(currentDay)
      const prediction = storage('prediction').load()
      if (prediction === 10) return
      if (!prediction){
        storage('prediction').save(1)
      } else {
        storage('prediction').save(prediction + 1)
      }
      setRandomText(randomPredictions.getRandomItem().text);
    }, [onRoute]);

    useEffect(()=>{
      const datePrediction = storage('datePrediction').load()
      const currentDay = getCurrentDate()
      if(datePrediction !== currentDay){
        storage('prediction').save()
      }
    },[])

    useEffect(()=>{
      setRandomText(null)
    },[onRoute])

    const {title, text, rules} = prediction;
    return (
      <section className={classNames(styles.prediction,className)} ref={ref}>
        <div className={styles.prediction__content}>
          <Tag className={styles.prediction__title}>{safeHTML(title)}</Tag>
          <p className={styles.prediction__text}>{safeHTML(text)}</p>
          <Button className={classNames(buttonStyles.button_black, buttonStyles.button_big)} text={"Узнать"}
                  onClick={onRoute || randomTextAction}
          />

          {randomText &&
          <SwitchTransition>
            <CSSTransition key={`text-${randomText}`} timeout={500} classNames={"prediction__result"}>
              <p className={styles.prediction__result}>
                {safeHTML(randomText)}
              </p>
            </CSSTransition>
          </SwitchTransition>
          }

          <div className={styles.prediction__rules}>
            <h3 className={styles.prediction__rulesTitle}>{safeHTML(rules?.title)}</h3>
            <p className={styles.prediction__rulesText}>{safeHTML(rules?.text)}</p>
          </div>
        </div>

      </section>
    );
  });


function getCurrentDate() {
  const today = new Date();
  const day = today.getDate().toString().padStart(2, '0'); // Добавляем 0 если число < 10
  const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Месяцы идут с 0
  const year = today.getFullYear();
  return `${day}-${month}-${year}`;
}

export default Prediction;
Prediction.propTypes = {};

